import { fetchWithRetry } from '../lib/fetchWithRetry/fetchWithRetry';
import { EnvironmentService } from '../EnvironmentService/EnvironmentService';
import { ResourceCollectionProcessor } from './collections/ResourceCollectionProcessor';
function buildNestedEntityFilter(modelName, values) {
    const textClause = values.map(v => `text::${v}`).join('|');
    return `enriched_html.entities:(model_name::${modelName},(${textClause}))`;
}
export class ResourceService {
    static getCollectionId() {
        return EnvironmentService.isEnvironment('prod')
            ? ResourceService.PROD_COLLECTION_ID
            : ResourceService.NON_PROD_COLLECTION_ID;
    }
    static getProcessor() {
        const collectionId = ResourceService.getCollectionId();
        const processor = ResourceService.processors[collectionId];
        if (!processor) {
            console.error(`No processor registered for collection ID: ${collectionId}`);
            return null;
        }
        return processor;
    }
    static buildFilter(subtopics, subTopicDetails) {
        const filters = [];
        // disable videos
        filters.push('enriched_html.video_id:!*');
        // exclude items with priority 0
        filters.push('enriched_html.entities:(model_name::priority,text:!0)');
        const hasSubtopics = subtopics?.length;
        const hasSubTopicDetails = subTopicDetails?.length;
        if (hasSubtopics && hasSubTopicDetails) {
            // OR the sub_topic and sub_topic_details filters so documents matching
            // either the parent topic or any selected detail are returned
            const subTopicFilter = buildNestedEntityFilter('sub_topic', subtopics);
            const subTopicDetailsFilter = buildNestedEntityFilter('sub_topic_details', subTopicDetails);
            filters.push(`(${subTopicFilter}|${subTopicDetailsFilter})`);
        }
        else if (hasSubtopics) {
            filters.push(buildNestedEntityFilter('sub_topic', subtopics));
        }
        else if (hasSubTopicDetails) {
            filters.push(buildNestedEntityFilter('sub_topic_details', subTopicDetails));
        }
        return filters.join(',');
    }
    static async fetchResourceData(subtopics, subTopicDetails, offset = 0, query, pageSize) {
        const processor = ResourceService.getProcessor();
        if (!processor) {
            return null;
        }
        const filter = ResourceService.buildFilter(subtopics, subTopicDetails);
        try {
            const response = await fetchWithRetry('/api/ampf/search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...(query && { query }),
                    collectionIds: [ResourceService.getCollectionId()],
                    sort: '-priority',
                    filter,
                    offset,
                    count: pageSize,
                    xReturn: [
                        'document_id',
                        'title',
                        'extracted_metadata.title',
                        'extracted_metadata.subject',
                        'extracted_metadata.file_type',
                        'extracted_metadata.filename',
                        'url',
                        'metadata.source.url',
                        'enriched_html',
                        'text'
                    ],
                    passages: { enabled: false }
                })
            });
            if (!response.ok) {
                console.error('Resource Center Fetch failed');
                return null;
            }
            const data = await response.json();
            const items = processor.processResults(data);
            return { items, matchingResults: data.matchingResults };
        }
        catch {
            console.error('Network error fetching resource center data');
            return null;
        }
    }
}
// TODO: Replace with production collection ID when determined
ResourceService.PROD_COLLECTION_ID = '';
ResourceService.NON_PROD_COLLECTION_ID = '91f95eb0-5c59-a7ef-0000-019e2c0f4143';
ResourceService.processors = {
    [ResourceService.PROD_COLLECTION_ID]: new ResourceCollectionProcessor(),
    [ResourceService.NON_PROD_COLLECTION_ID]: new ResourceCollectionProcessor()
};
